/**
 * AdSlot Model
 * Represents a single dfp ad slot and it's configuration
 */
define('AdModels/AdSlot',[],function () {
    "use strict";

    function AdSlot( config ) {
        this.id = config.id;                        // string       : DIV ID of Ad Slot
        this.position = config.position;            // string       : Position Value (eg. DT_ATF_TOP)
        this.vtier = config.vtier                   // string       : Tier Value
        this.roadblock = config.roadblock           // string       : Whether or not slot is Roadblock (eg. yes or no)
        this.sizes = config.sizes;                  // string       : Eligable Sizes (eg. 300x250)
        this.fluid = config.fluid;                  // bool         : Whethor or not slot is eligable for the fluid size
        this.outofpage = config.outofpage;          // bool         : Whether or not slot is out of page
        this.mobile = config.mobile;                // bool         : Whether or not slot is mobile
        this.dom = config.dom;                      // object       : reference to the dom object context
        this.def = {};                              // object       : dfp configuration object reference
        this.autorefresh = config.autorefresh;      // bool         : Whether or not to automatically refresh the slot on a time interval
        this.autorefreshstate = 0;                  // int          : Current state of slot for auto refresh
        this.loaded = config.loaded;                // bool         : Whether or not this slot has been loaded
        this.display = [0,0];                       // Array        : Target Display Size
        this.manual = config.manual;                // bool         : Whether or not slot is loaded manually
        this.limit = config.limit;                  // float        : Percentage of traffic to serve this ad slot where 1.0 is 100%
        this.isRoadBlock = false;                   // bool         : Whether or not this ad slot is part of a guarenteed roadblock
        this.lineItemId = '';                       // string       : Line Item Id that gets served by DFP
    }

    return AdSlot;
});
